import script from "./testTable.vue?vue&type=script&setup=true&lang=js"
export * from "./testTable.vue?vue&type=script&setup=true&lang=js"

import "./testTable.vue?vue&type=style&index=0&id=0a96adc7&scoped=true&lang=scss"
import "./testTable.vue?vue&type=style&index=1&id=0a96adc7&lang=scss"
import "./testTable.vue?vue&type=style&index=2&id=0a96adc7&scoped=true&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/fbdnextui_staging-uk-v3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a96adc7"]])

export default __exports__